import { windowOptions } from '@tv-casino/viewmodels/components/windowPickerModel.js';
import type { StatsWindow } from '@tv-casino/shared';
import styles from './WindowPicker.module.css';

/**
 * The time filter every market card shares: Tonight, 24 hours, 7 days, All
 * time. Pure render — the options come from the model, the change from the
 * route that owns the refetch.
 */
export function WindowPicker({
  value,
  onChange,
  label = 'Stats window',
}: {
  value: StatsWindow;
  onChange: (window: StatsWindow) => void;
  label?: string;
}) {
  return (
    <div className={styles.picker} role="group" aria-label={label}>
      {windowOptions().map((option) => (
        <button
          key={option.id}
          type="button"
          className={option.id === value ? styles.on : styles.off}
          aria-pressed={option.id === value}
          onClick={() => onChange(option.id)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
